import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Col,
  Row,
  Button,
} from "reactstrap";
import Select from "react-select";
import ButtonSpinner from "../../../../components/Buttons/ButtonSpinner";

export default function ModalStandReport({
  modalStandReportControl,
  setModalStandReportControl,
  groups,
  extractReportByGroup,
}) {
  return (
    <Modal
      isOpen={modalStandReportControl.open}
      toggle={() => {
        toggleBackdrop();
      }}
      autoFocus={true}
      centered={true}
    >
      <ModalHeader>Exportar relatório</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            extractReportByGroup(e);
          }}
        >
          <Row style={{ marginBottom: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Grupo</label>
                <Select
                  value={modalStandReportControl.group}
                  placeholder={"Selecione"}
                  onChange={(e) => setModalStandReportControl({ ...modalStandReportControl, group: e })}
                  options={[
                    {
                      options: [
                        ...groups.map((e) => {
                          return { label: e.name, value: e.id };
                        }),
                      ],
                    },
                  ]}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
          </Row>

          <Row
            style={{
              width: "100%",
              margin: "auto",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              color="danger"
              style={{ width: 80, marginRight: 10 }}
              onClick={() => setModalStandReportControl({ ...modalStandReportControl, open: false })}
            >
              Fechar
            </Button>
            <ButtonSpinner
              // isLoading={isLoading} 
              title={"Buscar"}
            />
          </Row>
        </form>
      </ModalBody>
    </Modal>
  )
}
